var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_c('HeaderActionButton',{attrs:{"on-pressed":_vm.onPressed},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('v-icon',[_vm._v("mdi-book-open-page-variant")])]},proxy:true}],null,true)})],1)]}}])},[_c('span',[_vm._v("Download User Manual")])])}
var staticRenderFns = []

export { render, staticRenderFns }